import { Box, Container, Typography } from "@mui/material"
import Page from "minimals-template/components/Page"
import { NoResults } from "lib/@components/no-results/no-results"
import { UpBar } from "routes/schedule/components/up-bar"

export function CompareEmptyState({ id, title, detail, children }) {
    return (
        <Page title={title}>
            <Container maxWidth="xl">
                <UpBar id={id} />
                <NoResults>
                    <Box sx={{ textAlign: "center" }} data-cy="compare-empty-state">
                        {title}
                        <Typography sx={{ opacity: 0.7 }} variant="caption" component="div" color="text.secondary">
                            {detail}
                        </Typography>
                        {children}
                    </Box>
                </NoResults>
            </Container>
        </Page>
    )
}
